import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from 'stores';
import { USER_MENU_URL } from 'data/menu';

function Unauthorize() {
  const { login, user } = useAppSelector((state) => state.auth);

  if (login) {
    // 회원 목록은 PlatformSuper 전용
    return (
      <Navigate
        to={
          user?.permissions.includes('user:list') ? USER_MENU_URL.회원목록 : '/'
        }
      />
    );
  }

  return <Outlet />;
}

export default Unauthorize;
